import { ImageCrop } from "@components/common/ui/ImageCrop";
import { Typography } from "@kirvanobr/typography";
import { Modal, ModalBody, ModalContent, ModalHeader } from "@kirvanobr/modal";
import { useThumbStore } from "./Thumb.store";
import { ThumbModalProps } from "./Thumb.types";
import Loader from "@components/layouts/Loader";

export default function ThumbModal({ handleUploadLogo, closeUploadModal }: ThumbModalProps) {
  const isUploadModalOpen = useThumbStore(state => state.isUploadModalOpen);
  const isLoading = useThumbStore(state => state.isLoading);
  const onCancel = useThumbStore(state => state.closeUploadModal);

  return (
    <Modal isOpen={isUploadModalOpen} onOpenChange={onCancel}>
      <ModalContent>
        <Loader loading={isLoading ?? false} />
        <ModalHeader>
          <Typography variant="title" size="t4">
            Upload de Thumbnail
          </Typography>
        </ModalHeader>

        <ModalBody>
          <ImageCrop
            initialAspectRatio={16 / 9}
            aspectRatio={16 / 9}
            onSubmit={handleUploadLogo}
            onCancel={closeUploadModal}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
